export interface DashboardCardConfig {
	label: string;
	icon: string;
	accent: string;
}

export const DASHBOARD_CARDS = {
	operator: {
		saphetyComission: {
			label: 'dashboard-card.operator.saphetyComission',
			icon: 'fa-regular fa-sack-dollar',
			accent: 'color-dashboard-purple',
		},
		totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections: {
			label: 'dashboard-card.operator.totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections',
			icon: 'fa-regular fa-building',
			accent: 'color-dashboard-indigo',
		},
		totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts: {
			label: 'dashboard-card.operator.totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts',
			icon: 'fa-regular fa-building',
			accent: 'color-dashboard-sky',
		},
		totalActiveConnections: {
			label: 'dashboard-card.operator.totalActiveConnections',
			icon: 'fa-regular fa-chart-network',
			accent: 'color-dashboard-green',
		},
	},
	confirming: {
		contractedAmount: {
			label: 'dashboard-card.confirming.contractedAmount',
			icon: 'fa-regular fa-chart-pie-simple-circle-dollar',
			accent: 'color-dashboard-purple',
		},
		contractsAvailableAmount: {
			label: 'dashboard-card.confirming.contractsAvailableAmount',
			icon: 'fa-regular fa-chart-pie-alt',
			accent: 'color-dashboard-indigo',
		},
		notPaidDocuments: {
			label: 'dashboard-card.confirming.notPaidDocuments',
			icon: 'fa-regular fa-file-invoice',
			accent: 'color-dashboard-sky',
		},
		approvedRequestFunds: {
			label: 'dashboard-card.confirming.approvedRequestFunds',
			icon: 'fa-regular fa-hand-holding-dollar',
			accent: 'color-dashboard-green',
		},
		currentFundingRequestsAmount: {
			label: 'dashboard-card.confirming.currentFundingRequestsAmount',
			icon: 'fa-regular fa-hand-holding-dollar',
			accent: 'color-dashboard-salmon',
		},
		averageMonthFundingRequestDays: {
			label: 'dashboard-card.confirming.averageMonthFundingRequestDays',
			icon: 'fa-regular fa-clock',
			accent: 'color-dashboard-yellow',
		},
		monthlyAutomaticPayments: {
			label: 'dashboard-card.confirming.monthlyAutomaticPayments',
			icon: 'fa-regular fa-usd-circle',
			accent: 'color-dashboard-purple',
		},
		buyersCompaniesCount: {
			label: 'dashboard-card.confirming.buyersCompaniesCount',
			icon: 'fa-regular fa-building',
			accent: 'color-dashboard-indigo',
		},
		suppliersCompaniesCount: {
			label: 'dashboard-card.confirming.suppliersCompaniesCount',
			icon: 'fa-regular fa-building',
			accent: 'color-dashboard-sky',
		},
		suppliersActiveConnections: {
			label: 'dashboard-card.confirming.suppliersActiveConnections',
			icon: 'fa-regular fa-chart-network',
			accent: 'color-dashboard-green',
		},
		pendingApprovalDocumentsAmount: {
			label: 'dashboard-card.confirming.pendingApprovalDocumentsAmount',
			icon: 'fa-regular fa-hourglass-clock',
			accent: 'color-dashboard-orange',
		},

		// BUYER ONLY
		companies: {
			label: 'dashboard-card.confirming.companies',
			icon: 'fa-regular fa-building',
			accent: 'color-dashboard-indigo',
		},
	},
	factoring: {
		approvedCreditAssignments: {
			label: 'dashboard-card.factoring.approvedCreditAssignments',
			icon: 'fa-regular fa-hands-usd',
			accent: 'color-dashboard-purple',
		},
		currentCreditAssignmentsAmount: {
			label: 'dashboard-card.factoring.currentCreditAssignmentsAmount',
			icon: 'fa-regular fa-hands-usd',
			accent: 'color-dashboard-indigo',
		},
		approvedAdvances: {
			label: 'dashboard-card.factoring.approvedAdvances',
			icon: 'fa-regular fa-money-check-alt',
			accent: 'color-dashboard-sky',
		},
		contractDocumentPortfolioAmount: {
			label: 'dashboard-card.factoring.contractDocumentPortfolioAmount',
			icon: 'fa-regular fa-chart-pie-alt',
			accent: 'color-dashboard-green',
		},
		contractedAmount: {
			label: 'dashboard-card.factoring.contractedAmount',
			icon: 'fa-regular fa-chart-pie-simple-circle-dollar',
			accent: 'color-dashboard-orange',
		},
		contractAdvanceableAmount: {
			label: 'dashboard-card.factoring.contractAdvanceableAmount',
			icon: 'fa-regular fa-chart-pie-alt',
			accent: 'color-dashboard-purple',
		},
		suppliersWithActiveContractsCompaniesCount: {
			label: 'dashboard-card.factoring.suppliersWithActiveContractsCompaniesCount',
			icon: 'fa-regular fa-building',
			accent: 'color-dashboard-indigo',
		},
		buyersWithActiveConnectionsCompaniesCount: {
			label: 'dashboard-card.factoring.buyersWithActiveConnectionsCompaniesCount',
			icon: 'fa-regular fa-building',
			accent: 'color-dashboard-sky',
		},
		buyersActiveConnections: {
			label: 'dashboard-card.factoring.buyersActiveConnections',
			icon: 'fa-regular fa-chart-network',
			accent: 'color-dashboard-green',
		},
		pendingApprovalDocumentsAmount: {
			label: 'dashboard-card.factoring.pendingApprovalDocumentsAmount',
			icon: 'fa-regular fa-hourglass-clock',
			accent: 'color-dashboard-orange',
		},

		// SUPPLIER ONLY
		portfolioAmount: {
			label: 'dashboard-card.factoring.portfolioAmount',
			icon: 'fa-regular fa-hands-usd',
			accent: 'color-dashboard-green',
		},
		advancedAmount: {
			label: 'dashboard-card.factoring.advancedAmount',
			icon: 'fa-regular fa-money-check-alt',
			accent: 'color-dashboard-orange',
		},
		advanceableAmount: {
			label: 'dashboard-card.factoring.advanceableAmount',
			icon: 'fa-regular fa-money-check-alt',
			accent: 'color-dashboard-purple',
		},
	},
} as const satisfies Record<string, Record<string, DashboardCardConfig>>;

export type DashboardCardSection = keyof typeof DASHBOARD_CARDS;

export type DashboardCardId = {
	[S in DashboardCardSection]: `${S}.${keyof (typeof DASHBOARD_CARDS)[S] & string}`;
}[DashboardCardSection];

export function getDashboardCard(id: DashboardCardId): DashboardCardConfig {
	const separatorIndex = id.indexOf('.');
	const section = id.substring(0, separatorIndex) as DashboardCardSection;
	const cardId = id.substring(separatorIndex + 1) as keyof (typeof DASHBOARD_CARDS)[typeof section];
	return DASHBOARD_CARDS[section][cardId];
}

